import { Properties } from 'xlsx';

declare global {
	const XLSX : typeof import('xlsx');
}

function s2ab(s : string) {
	const buf = new ArrayBuffer(s.length); // Convert s to arrayBuffer
	const view = new Uint8Array(buf);  // Create uint8array as viewer
	for (let i = 0; i < s.length; i++) {
		view[i] = s.charCodeAt(i) & 0xFF; // Convert to octet
	}

	return buf;
}

export function getXlsxBlob(
	headers : string[],
	rows : string[][],
	sheetName : string,
	props : Properties,
) {
	const wb = XLSX.utils.book_new();
	wb.Props = props;

	const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);

	wb.SheetNames.push(sheetName);
	wb.Sheets[sheetName] = ws;

	const result = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

	return new Blob([s2ab(result)], { type: 'application/vnd.ms-excel' });
}

export {};



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/export.ts